import { render, staticRenderFns } from "./ReportSiteConfigFullPodTransactional.vue?vue&type=template&id=15644bf0&scoped=true&"
import script from "./ReportSiteConfigFullPodTransactional.vue?vue&type=script&lang=js&"
export * from "./ReportSiteConfigFullPodTransactional.vue?vue&type=script&lang=js&"
import style0 from "./ReportSiteConfigFullPodTransactional.vue?vue&type=style&index=0&id=15644bf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15644bf0",
  null
  
)

export default component.exports